import { InternalAxiosRequestConfig } from "axios";
import { getAccessToken } from "../auth-utils";
import { isPublicEndpoint } from "../config/endpoints";
import { RequestInterceptor } from "../types/http-types";

/**
 * Authentication Request Interceptor
 * Handles token management for API requests
 * Follows SRP: Single responsibility - authentication only
 */
export class AuthInterceptor implements RequestInterceptor {
  /**
   * Add authentication token to requests that require it
   */
  async onRequest(
    config: InternalAxiosRequestConfig
  ): Promise<InternalAxiosRequestConfig> {
    const requestUrl = config.url || "";

    // Check if this is a public endpoint that doesn't need authentication
    if (isPublicEndpoint(requestUrl)) {
      delete config.headers.Authorization;
      return config;
    }

    // Get token from auth utils
    const token = getAccessToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
      if (process.env.NODE_ENV === "development") {
        console.warn(`[Auth Interceptor] No valid token for ${requestUrl}`);
      }
    }

    return config;
  }

  onRequestError(error: any) {
    return Promise.reject(error);
  }
}

/**
 * Singleton instance for use across HTTP clients
 */
export const authInterceptor = new AuthInterceptor();
